import size from 'lodash/size';
import mapValues from 'lodash/mapValues';
import createSuccessPromiseThunk from "~/rx/lib/createSuccessPromiseThunk";
import createModelApi from "~/backend/modelApi";
import {
    getItemId, getModelName, getPrimaryKeyAttr, getSubviews, getValueAdaptData,
    getValueAdaptSources,
} from "~/stateGetter";
import identify from "~/identify";
import {modify} from "mythil/object";
import {
    getSaveValues,
    presentPrimaryKey, presentSaveEditFields,
} from "~/statePresenter";
import {pushClose, pushCurrentModelPath, smartGoto} from "~/actions/navigation_actions";
import invalidateLoadedModels from "~/reducers/helpers/invalidateLoadedModels";
import {prepareItemData} from "~/data/dataPreparer";
import authenticatedRequest from "~/backend/authenticatedRequest";

const itemSave = createSuccessPromiseThunk({
    func: async ({modelId, getState, dispatch, getConfig}) => {
        let state = getState(),
            modelApi = createModelApi(
                getConfig().baseUrl,
                getModelName(state, modelId),
                (foo) => authenticatedRequest(foo, dispatch)
            ),
            itemId = getItemId(state, modelId),
            saveValues = getSaveValues(state, modelId),
            saveResult = await modelApi.saveItem(itemId, saveValues);

        let subviews = getSubviews(state, modelId);

        if(!saveResult.success) { return saveResult; }
        if(saveResult.redirect) {
            dispatch(smartGoto(saveResult.redirect, {noConfirm: true}));
            return saveResult;
        }

        let prevItemId = itemId;

        itemId = presentPrimaryKey({
            values: saveResult.values,
            primaryKeyAttr: getPrimaryKeyAttr(state, modelId),
            defaultKey: itemId
        });

        saveResult.itemId = `${itemId}`;

        if(itemId !== identify.NEW_ITEM && size(subviews) > 0) {
            let mode = prevItemId === identify.NEW_ITEM ? 'edit' : 'view';

            dispatch(pushCurrentModelPath(`/${itemId}/${mode}`, {includeCurrent: true}, {noConfirm: true}))
        } else {
            dispatch(pushClose({noConfirm: true}));
        }

        return prepareItemData(saveResult);
    },
    name: 'saveItem',
});

let execute = itemSave.execute;
itemSave.execute = (modelId) => execute({modelId}, {modelId});

let reduce = itemSave.reduce;
itemSave.reduce = (model, action, state) => {
    model = modify(model, 'saveResult', (saveResult) => {
        switch(action.type) {
            case itemSave.types.SUCCESS:
                return {
                    ...saveResult,
                    status: identify.STATUS_SUCCESS,
                    finished_at: Date.now(),
                    value: {
                        messages: action.value.messages
                    }
                };
            // TODO
            default:
                return reduce(saveResult, action);
        }
    });


    return model;
};

itemSave.reduceState = (state, action) => {
    switch(action.type) {
        case itemSave.types.SUCCESS:
            return invalidateLoadedModels(state);
        default:
            return state;
    }
};

const reduceSaveItem = itemSave.reduce,
    SAVE_ITEM_TYPES = itemSave.types,
    saveItem = itemSave.execute,
    reduceItemSaveState = itemSave.reduceState;

export {
    reduceSaveItem,
    reduceItemSaveState,
    SAVE_ITEM_TYPES,
    saveItem,
}